import { render, staticRenderFns } from "./DocumentRequired.vue?vue&type=template&id=602fbebc&scoped=true"
import script from "./DocumentRequired.vue?vue&type=script&lang=js"
export * from "./DocumentRequired.vue?vue&type=script&lang=js"
import style0 from "./DocumentRequired.vue?vue&type=style&index=0&id=602fbebc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602fbebc",
  null
  
)

export default component.exports